import React from "react"
import { isMobile } from "react-device-detect"
import { withRouter } from "react-router-dom"
import { view } from "react-easy-state"
import { message } from "antd"

import Footer from "components/common/layouts/Footer"
import ContentLoader from "components/common/ContentLoader"
import ContentLoadingFailed from "components/common/ContentLoadingFailed"
import PaperDetails from "components/pages/students/papers/show/PaperDetails"
import PaperListSider from "components/pages/students/papers/show/PaperListSider"

import globalStore from "store"

import PapersService from "services/students/papers.service"
import AskDoubt from "components/pages/students/AskDoubt"

class PapersShowPage extends React.Component {
  async componentDidMount() {
    const { paperId } = this.props.match.params

    const pageState = globalStore.ui.students.papers.show
    await PapersService.show({ pageState, paperId })
  }

  renderPaperContent() {
    const pageState = globalStore.ui.students.papers.show
    const {
      paper,
      subject,
      course,
      paper_attempt,
      paperErrors,
      API_PAPERS_SHOW_STATUS,
    } = pageState

    if (!API_PAPERS_SHOW_STATUS) return <ContentLoader />
    if (API_PAPERS_SHOW_STATUS === "pending") return <ContentLoader />
    if (API_PAPERS_SHOW_STATUS === "rejected") return <ContentLoadingFailed />

    if (paperErrors) {
      message.destroy()
      message.error(paperErrors)
      this.props.history.replace(`/courses`)
      return
    }

    const courseSubscription = pageState.course_subscription
    const evaluation_feature = courseSubscription.subscription_features.filter(
      (s) => s.feature === "evaluation"
    )

    let coursePaymentDone = false
    pageState.backUrl = `/courses/${course.id}/subjects`

    console.log("evaluation_feature", evaluation_feature)

    if (evaluation_feature.length > 0) {
      coursePaymentDone = true
    } else {
      const { paperId } = this.props.match.params

      globalStore.ui.students.course_subscriptions.payment = {
        courseId: course.id,
        subjectId: subject.id,
        paperId,
      }
    }

    // if (evaluation_feature.length === 0) {
    //   const { paperId, subjectId } = this.props.match.params

    //   globalStore.ui.students.papers.show = {}
    //   globalStore.ui.students.course_subscriptions.payment = {
    //     subjectId,
    //     paperId,
    //   }
    //   return <Redirect to='/courses/1/payment' />
    // }

    return (
      <React.Fragment>
        <PaperListSider />
        <PaperDetails
          paper={paper}
          paperAttempt={paper_attempt}
          coursePaymentDone={coursePaymentDone}
        />
      </React.Fragment>
    )
  }

  componentWillUnmount() {
    globalStore.ui.students.papers.show = {}
  }

  render() {
    return (
      <div className={`page lecture-page ${isMobile ? "mobile" : ""}`}>
        {this.renderPaperContent()}
        <Footer />
        <AskDoubt />
      </div>
    )
  }
}

export default withRouter(view(PapersShowPage))
